import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '@reducers/user';
import { FeatureFlagsAvailable } from '@components/featureFlags';
import { IMAGE_ANNOTATION_FEATURE_FLAG } from '@v2/components/imageHandling/components/DrawingCanvas/constants';

export const useAnnotationModeEnabled = () => {
  const featureFlags = useSelector(selectFeatureFlags);

  const isAnnotationModeEnabled = FeatureFlagsAvailable(IMAGE_ANNOTATION_FEATURE_FLAG, featureFlags);

  return isAnnotationModeEnabled;
};
